var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { Modal } from '@hn-ui/modals';
import { ActivityStreamAccuracyHelp } from './ActivityStreamAccuracyHelp';
import { ListContainer, PositionedInfoBtn, } from '../../Common';
import { useMemo } from 'react';
var COMMON_HEADINGS = [
    'Started',
    'Status',
    'Time spent',
    'Accuracy',
];
var ScContainer = styled(ListContainer).withConfig({ displayName: "ScContainer", componentId: "sc-14n45xn" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 32px;\n  padding-bottom: 16px;\n  border: none;\n"], ["\n  min-height: 32px;\n  padding-bottom: 16px;\n  border: none;\n"])));
var Heading = styled.h3.withConfig({ displayName: "Heading", componentId: "sc-129p97v" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  margin: 0;\n  color: #242527;\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  &:not(:first-child) {\n    text-align: right;\n  }\n  white-space: pre-line;\n"], ["\n  position: relative;\n  margin: 0;\n  color: #242527;\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  &:not(:first-child) {\n    text-align: right;\n  }\n  white-space: pre-line;\n"])));
var TasksTableHeader = function (_a) {
    var _b = _a.firstColumnName, firstColumnName = _b === void 0 ? 'Task' : _b, _c = _a.hideColumnsHeading, hideColumnsHeading = _c === void 0 ? false : _c, _d = _a.isWeekly, isWeekly = _d === void 0 ? false : _d, withoutLeftPadding = _a.withoutLeftPadding, hasTopPadding = _a.hasTopPadding, isReport = _a.isReport, props = __rest(_a, ["firstColumnName", "hideColumnsHeading", "isWeekly", "withoutLeftPadding", "hasTopPadding", "isReport"]);
    var headings = useMemo(function () { return __spreadArray([firstColumnName], (hideColumnsHeading ? [] : COMMON_HEADINGS), true); }, [firstColumnName, hideColumnsHeading]);
    var _e = useToggle(false), isHowToRead = _e.isToggled, toggleHowToRead = _e.toggle;
    return (_jsx(ScContainer, __assign({}, props, { "$withoutLeftPadding": withoutLeftPadding, "$hasTopPadding": hasTopPadding, "$isReport": isReport, "data-name": 'tasks-header' }, { children: headings.map(function (txt) {
            var label = ['Accuracy', 'Time spent'].includes(txt) && isWeekly
                ? txt + "\n  this week"
                : txt;
            return (_jsxs(Heading, __assign({ "data-name": 'heading-cell' }, { children: [label, txt === 'Accuracy' && (_jsxs(_Fragment, { children: [_jsx(PositionedInfoBtn, { "data-testid": 'modal-window-icon', onClick: toggleHowToRead }, void 0), _jsx(Modal, __assign({ open: isHowToRead, onClose: toggleHowToRead, showOverlay: true, "data-testid": 'modal-window-test', size: 'l' }, { children: _jsx(ActivityStreamAccuracyHelp, {}, void 0) }), void 0)] }, void 0))] }), txt));
        }) }), void 0));
};
export { TasksTableHeader };
var templateObject_1, templateObject_2;
